<ts-admin-override-banner
  *ngIf="active_device && is_admin"
  [admin_override]="devices_payload.include_admin_options"
  [prevent_default]="admin_cart_items"
  [disabled]="disable_admin_overide"
  (emit_cart_change)="confirmAdminToggleClearCart($event)"
  (emit_admin_override)="getAdminOverride($event)"
/>

<div *ngIf="active_device" class="container-md pb-4 pb-sm-0 p-md-0 pb-md-2 device-details">
  <div class="row g-4">
    <div class="col-12 col-lg-5">
      <ts-device-image-placeholder
        [device]="active_device"
        [device_carrier]="selected_devices_by_carrier"
      />
    </div>

    <div class="col-12 col-lg-7">
      <div class="row flex-column gap-2rem">
        <div class="col">
          <ts-device-description [device]="active_device" [is_bp_device]="is_bp_device" />
        </div>

        <div class="col">
          <ts-device-carrier
            [device_items]="device_record"
            [selected_carrier_id]="selected_carrier_id"
            [is_bp_device]="is_bp_device"
            (selected_carrier)="selectCarrierClick($event)"
          />
        </div>

        <!-- Color Section -->
        <div
          *ngIf="normalized_device_list_by_color.length && ![3].includes(this.current_activity_id)"
          class="col"
        >
          <h4 class="mb-3 display-4">{{ 'color' | translate }}</h4>
          <hr class="mb-3" />
          <div class="row row-cols-7 row-cols-md-12 g-3">
            <div *ngFor="let device of normalized_device_list_by_color" class="col col-auto">
              <div
                as-button
                class="device-color"
                [class.device-color__active]="device.id === selected_color_device_id"
                [class.elevate]="device.id !== selected_color_device_id"
                [style.background-color]="device.color | lowercase"
                [attr.aria-label]="device.original_color"
                (click)="selectColorClick(device)"
              ></div>
            </div>
          </div>
          <h5 class="mt-3 mb-0" *ngIf="active_device.original_color || active_device.color">
            {{ active_device.original_color || active_device.color }}
          </h5>
        </div>

        <!-- Storage Capacity -->
        <div *ngIf="storage_list.length && ![3].includes(this.current_activity_id)" class="col">
          <h4 class="mb-3 display-4">
            {{ 'storage_capacity' | translate }}
          </h4>
          <hr class="mb-3" />
          <div class="row row-cols-2 row-cols-md-4 g-3">
            <div *ngFor="let device of storage_list" class="col">
              <div
                as-button
                class="card overflow-auto h-100"
                [ngClass]="{ 'p-3': device.admin }"
                [class.active-card]="getActiveStorage(device)"
                [class.elevate]="
                  device.size !== selected_storage_size || device.id != selected_storage_device_id
                "
                [attr.aria-label]="device.size"
                (click)="selectStorageClick(device)"
              >
                <div class="card-body flex-column d-flex align-items-center justify-content-center">
                  <h5 class="mb-1">{{ device.size }}</h5>
                  <small class="text-secondary fw-normal">
                    {{ device.price.onetime.cost_to_currency }}
                  </small>
                  <span
                    *ngIf="!!device.price?.monthly?.cost_to_currency"
                    class="text-secondary text-size-sm fw-normal"
                  >
                    {{ 'plus' | translate }}
                    {{ appendMonthlyLabel(device.price.monthly.cost_to_currency) }}
                  </span>
                </div>

                <ng-container *ngTemplateOutlet="adminBadge; context: { admin: device.admin }" />
              </div>
            </div>
          </div>
        </div>

        <!-- Name Overrides -->
        <div *ngIf="name_override_list.length > 0 && show_options" class="col">
          <h4 class="mb-3 display-4">
            {{ 'options' | translate }}
            <span class="text-secondary fs-6"> ({{ 'choose_one' | translate }}) </span>
          </h4>
          <hr class="mb-3" />
          <div class="row row-cols-1 g-3">
            <div *ngFor="let device of name_override_list" class="col">
              <div
                as-button
                class="card"
                [ngClass]="{ 'p-2': device.admin }"
                [class.active-card]="device.id === selected_name_override_id"
                [class.elevate]="device.id !== selected_name_override_id"
                [attr.aria-label]="device.name_override || device.name"
                (click)="selectNameOverrideClick(device)"
              >
                <div class="card-body">
                  <h5 class="mb-1">{{ device.name_override || device.name }}</h5>
                </div>

                <ng-container *ngTemplateOutlet="adminBadge; context: { admin: device.admin }" />
              </div>
            </div>
          </div>
        </div>

        <!-- Business Plans -->
        <div *ngIf="storage_list.length" class="col">
          <h4 class="mb-3 display-4">
            {{ 'business_plans' | translate }}
            <span class="text-secondary fs-6"> ({{ 'choose_one' | translate }}) </span>
          </h4>
          <hr class="mb-3" />
          <div
            class="row g-3"
            [tds-data-loader]="{
              key: 'device-plans',
              as_overlay: true,
              size: 'sm',
              class: 'align-items-start z-0 pt-1'
            }"
          >
            <!-- Default message -->
            <div *ngIf="plan_list.length === 0 && !no_plans" class="col-12">
              <div class="alert alert-primary" role="alert">
                <span>{{ 'business_plans_hint' | translate }}</span>
              </div>
            </div>

            <!-- No Plans available -->
            <div *ngIf="selected_storage_size !== '' && no_plans && !keep_plan" class="col-12">
              <div class="alert alert-warning" role="alert">
                <span>{{ 'business_plans_no_results' | translate }}</span>
              </div>
            </div>

            <!-- Message based on valid keep plan -->
            <div *ngIf="keep_plan" class="col-12">
              <div class="alert alert-primary" role="alert">
                <span>{{ 'keep_plan_opt_in' | translate }}</span>
              </div>
            </div>

            <div *ngFor="let plan of plan_list; let i = index" class="col-12">
              <div
                as-button
                class="card"
                [class.active-card]="plan.id == selected_plan_id"
                [class.elevate]="plan.id != selected_plan_id"
                [class.cursor-default]="plan.id == selected_plan_id"
                [attr.aria-label]="plan"
                (click)="plan.id == selected_plan_id ? $event.stopPropagation() : selectPlan(plan)"
              >
                <div class="card-body">
                  <div class="row d-flex justify-content-between">
                    <div class="col">
                      <img
                        class="img-fluid"
                        [src]="plan?.carrier?.image_url"
                        [alt]="plan?.carrier?.name"
                      />
                      <h5 class="mt-2 line-clamp-2">
                        {{ plan.name_override ? plan.name_override : plan.name }}
                      </h5>
                      <button
                        stop-click-propagation
                        *ngIf="sanitizedHTML(plan.full_description)"
                        class="btn btn-link neutral-btn text-capitalize fw-light text-decoration-underline px-1 ms-n1 focus-visible"
                        (click)="
                          openDetailsModal(
                            plan,
                            plan.description
                              ? plan.full_description + ' ' + plan.description
                              : plan.full_description
                          )
                        "
                      >
                        {{ 'view_details' | translate }}
                      </button>
                    </div>
                    <div class="col col-auto text-end d-flex">
                      <span *ngIf="keep_plan" class="d-flex align-items-center me-4">
                        <ts-badge text="{{ 'unchanged' | translate }}" />
                      </span>
                      <span *ngIf="plan.cost_to_currency">
                        <h5 class="my-0">{{ plan.cost_to_currency }}</h5>
                        <small class="text-secondary d-block">
                          {{ 'per_month' | translate }}
                        </small>
                      </span>
                    </div>
                  </div>
                </div>

                <ng-container *ngTemplateOutlet="adminBadge; context: { admin: plan.admin }" />
              </div>
            </div>
          </div>
        </div>

        <!-- Add On Features -->
        <div *ngIf="plan_list.length" class="col">
          <h4 class="mb-3 display-4">
            {{ 'add_on_features' | translate }}
          </h4>
          <hr class="mb-3" />
          <div
            class="row g-3"
            [tds-data-loader]="{
              key: 'device-plan-features',
              as_overlay: true,
              size: 'sm',
              class: 'align-items-start z-0 pt-1'
            }"
          >
            <!-- Default message -->
            <ng-template #defaultMessage>
              <div *ngIf="feature_list?.length === 0" class="col">
                <div class="alert alert-primary" role="alert">
                  {{ 'accessories_hint' | translate }}
                </div>
              </div>
            </ng-template>

            <!-- No Features available -->
            <div *ngIf="no_features; else defaultMessage">
              <div class="col-12">
                <div class="alert alert-warning" role="alert">
                  {{ 'features_no_results' | translate }}
                </div>
              </div>
            </div>

            <div *ngFor="let feature of feature_list; let i = index" class="col-12">
              <div
                as-button
                class="card"
                [class.adjust-badge-height]="!sanitizedHTML(feature?.description)"
                [class.last-feature]="i === feature_list.length - 1"
                [class.active-card]="getActiveFeatures(feature)"
                [class.cursor-default]="feature.included || keep_plan"
                [class.elevate]="!getActiveFeatures(feature)"
                [attr.aria-label]="feature.name_override ? feature.name_override : feature.name"
                (click)="
                  feature.included || keep_plan ? $event.stopPropagation() : selectFeature(feature)
                "
              >
                <div class="card-body">
                  <div class="row d-flex justify-content-between">
                    <div class="col">
                      <h5 class="line-clamp-2">
                        {{ feature.name_override ? feature.name_override : feature.name }}
                      </h5>
                      <button
                        stop-click-propagation
                        *ngIf="sanitizedHTML(feature?.description)"
                        class="btn btn-link neutral-btn text-capitalize fw-light text-decoration-underline px-1 ms-n1 focus-visible"
                        (click)="openDetailsModal(feature, feature.description)"
                      >
                        {{ 'view_details' | translate }}
                      </button>
                    </div>
                    <div *ngIf="keep_plan" class="col col-auto text-end d-flex">
                      <span class="d-flex align-items-center">
                        <ts-badge text="{{ 'unchanged' | translate }}" />
                      </span>
                    </div>
                    <div
                      *ngIf="feature.cost_to_currency || feature.cost"
                      class="col col-auto text-end d-flex"
                    >
                      <span *ngIf="feature.included" class="d-flex align-items-center me-4">
                        <ts-badge text="{{ 'included' | translate }}" />
                      </span>
                      <span>
                        <h5 class="my-0">
                          {{ feature.cost_to_currency || feature?.cost?.cost_to_currency }}
                        </h5>
                        <small class="text-secondary d-block">
                          {{ 'per_month' | translate }}
                        </small>
                      </span>
                    </div>
                  </div>
                </div>

                <ng-container *ngTemplateOutlet="adminBadge; context: { admin: feature.admin }" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ts-price-summary
  *ngIf="device_record?.length"
  [id]="device_plan.deviceId"
  [navigate_page]="page_to_navigate"
  [button_status]="disable_continue_btn || content_loading"
  [reset_cart]="[2, 3, 4, 5].includes(current_activity_id) ? false : true"
  [shopping_cart]="shopping_cart"
  [shopping_items_price]="shopping_items_price"
  [is_display_one_time_cost]="is_display_one_time_cost"
  [is_display_recurring_cost]="is_display_one_time_cost"
  [keep_plan]="keep_plan"
  [refresh_summary]="refresh_summary.asObservable()"
  (updateCostSummary)="getShoppingCartData($event)"
/>

<ng-template #adminBadge let-admin="admin">
  <ts-admin-override-badge
    *ngIf="admin"
    class="position-absolute bottom-0 end-0 border-top-left-radius"
  />
</ng-template>
